import { render, staticRenderFns } from "./SurveySubmitted.vue?vue&type=template&id=2e289dfe&scoped=true&"
import script from "./SurveySubmitted.vue?vue&type=script&lang=js&"
export * from "./SurveySubmitted.vue?vue&type=script&lang=js&"
import style0 from "./SurveySubmitted.vue?vue&type=style&index=0&id=2e289dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e289dfe",
  null
  
)

export default component.exports